var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__account-item header__account--basket"},[_c('a',{staticClass:"h-link",attrs:{"href":_vm.link}},[(_vm.count > 0)?_c('span',[_vm._v(_vm._s(_vm.count))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }